import { jsx } from "panel";
import { getFestiveMode } from "common/util/festive-mode";
import { LottieEl } from "../lottie";
import { SvgIconEl } from "../svg-icon";
import { SpinnerColor, SpinnerSize, SpinnerTheme } from "./types";
import limitedSegLottie from "./limited-seg.lottie";
export function template() {
  const festiveMode = getFestiveMode();
  const showFestiveModeSpinner = this.attr(`allow-festive`) && !!festiveMode;
  const showCustomSpinner = showFestiveModeSpinner || this.attr(`theme`) !== SpinnerTheme.Default;
  let spinnerClass = {
    "mp-spinner": true,
    "mp-spinner-blue": this.attr(`color`) === SpinnerColor.Blue,
    "mp-spinner-white": this.attr(`color`) === SpinnerColor.White,
    "mp-spinner-inherit-color": this.attr(`color`) === SpinnerColor.Inherit
  };
  if (showCustomSpinner) {
    spinnerClass = {
      "custom-spinner": true,
      ...showFestiveModeSpinner ? { [festiveMode]: true } : { [this.attr(`theme`)]: true }
    };
  }
  return /* @__PURE__ */ jsx("div", {
    class: {
      ...spinnerClass,
      "large-spinner": this.attr(`size`) === SpinnerSize.Large,
      "medium-spinner": this.attr(`size`) === SpinnerSize.Medium
    }
  }, !showCustomSpinner ? /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `spinner` }
  }) : null, this.attr(`theme`) === SpinnerTheme.Fancy && /* @__PURE__ */ jsx(LottieEl, {
    attrs: {
      config: { path: limitedSegLottie }
    }
  }));
}
